/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Adjust_CropInputs */

const en_mobile_scan_adjust_crop = /** @type {(inputs: Mobile_Scan_Adjust_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust crop`)
};

const es_mobile_scan_adjust_crop = /** @type {(inputs: Mobile_Scan_Adjust_CropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar recorte`)
};

/**
* | output |
* | --- |
* | "Adjust crop" |
*
* @param {Mobile_Scan_Adjust_CropInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_adjust_crop = /** @type {((inputs?: Mobile_Scan_Adjust_CropInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Adjust_CropInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_adjust_crop(inputs)
	return en_mobile_scan_adjust_crop(inputs)
});